(function (app, ng) {
    app.controller("SubmitPaperApplicationController", SubmitPaperApplicationController);

    SubmitPaperApplicationController.$inject = ['_', 'arcBusinessApi', 'figToaster', '$mdDialog', '$q', 'reportsApi'];
    function SubmitPaperApplicationController(_, arcBusinessApi, figToaster, $mdDialog, $q, reportsApi) {
        var $ctrl = this;

        $ctrl.closeDialog = function (event) {
            $mdDialog.hide(event);
        }

        ng.extend($ctrl, {
            ui: {
                loading: false,
                isSubmitting: false
            },
            paperApplication: {
                //ClientFirstName: "",
                //ClientLastName: "",
                //PublicProductGuid: null,
                //StateId: null,
                Notes: ""
            },
            carrier: null,
            carrierGuid: null,
            product: null,
            searchTextProduct: "",
            searchTextCarrier: "",
            states: [{ StateID: 2, State: "AL", StateName: "Alabama", IsVisible: true }, { StateID: 1, State: "AK", StateName: "Alaska", IsVisible: true }, { StateID: 4, State: "AZ", StateName: "Arizona", IsVisible: true }, { StateID: 3, State: "AR", StateName: "Arkansas", IsVisible: true }, { StateID: 5, State: "CA", StateName: "California", IsVisible: true }, { StateID: 6, State: "CO", StateName: "Colorado", IsVisible: true }, { StateID: 7, State: "CT", StateName: "Connecticut", IsVisible: true }, { StateID: 9, State: "DE", StateName: "Delaware", IsVisible: true }, { StateID: 8, State: "DC", StateName: "District Of Columbia", IsVisible: true }, { StateID: 10, State: "FL", StateName: "Florida", IsVisible: true }, { StateID: 11, State: "GA", StateName: "Georgia", IsVisible: true }, { StateID: 12, State: "HI", StateName: "Hawaii", IsVisible: true }, { StateID: 14, State: "ID", StateName: "Idaho", IsVisible: true }, { StateID: 15, State: "IL", StateName: "Illinois", IsVisible: true }, { StateID: 16, State: "IN", StateName: "Indiana", IsVisible: true }, { StateID: 13, State: "IA", StateName: "Iowa", IsVisible: true }, { StateID: 17, State: "KS", StateName: "Kansas", IsVisible: true }, { StateID: 18, State: "KY", StateName: "Kentucky", IsVisible: true }, { StateID: 19, State: "LA", StateName: "Louisiana", IsVisible: true }, { StateID: 22, State: "ME", StateName: "Maine", IsVisible: true }, { StateID: 21, State: "MD", StateName: "Maryland", IsVisible: true }, { StateID: 20, State: "MA", StateName: "Massachusetts", IsVisible: true }, { StateID: 23, State: "MI", StateName: "Michigan", IsVisible: true }, { StateID: 24, State: "MN", StateName: "Minnesota", IsVisible: true }, { StateID: 26, State: "MS", StateName: "Mississippi", IsVisible: true }, { StateID: 25, State: "MO", StateName: "Missouri", IsVisible: true }, { StateID: 27, State: "MT", StateName: "Montana", IsVisible: true }, { StateID: 30, State: "NE", StateName: "Nebraska", IsVisible: true }, { StateID: 34, State: "NV", StateName: "Nevada", IsVisible: true }, { StateID: 31, State: "NH", StateName: "New Hampshire", IsVisible: true }, { StateID: 32, State: "NJ", StateName: "New Jersey", IsVisible: true }, { StateID: 33, State: "NM", StateName: "New Mexico", IsVisible: true }, { StateID: 35, State: "NY", StateName: "New York", IsVisible: true }, { StateID: 28, State: "NC", StateName: "North Carolina", IsVisible: true }, { StateID: 29, State: "ND", StateName: "North Dakota", IsVisible: true }, { StateID: 36, State: "OH", StateName: "Ohio", IsVisible: true }, { StateID: 37, State: "OK", StateName: "Oklahoma", IsVisible: true }, { StateID: 38, State: "OR", StateName: "Oregon", IsVisible: true }, { StateID: 39, State: "PA", StateName: "Pennsylvania", IsVisible: true }, { StateID: 40, State: "PR", StateName: "Puerto Rico", IsVisible: true }, { StateID: 41, State: "RI", StateName: "Rhode Island", IsVisible: true }, { StateID: 42, State: "SC", StateName: "South Carolina", IsVisible: true }, { StateID: 43, State: "SD", StateName: "South Dakota", IsVisible: true }, { StateID: 44, State: "TN", StateName: "Tennessee", IsVisible: true }, { StateID: 45, State: "TX", StateName: "Texas", IsVisible: true }, { StateID: 46, State: "UT", StateName: "Utah", IsVisible: true }, { StateID: 48, State: "VT", StateName: "Vermont", IsVisible: true }, { StateID: 54, State: "VI", StateName: "Virgin Islands", IsVisible: true }, { StateID: 47, State: "VA", StateName: "Virginia", IsVisible: true }, { StateID: 49, State: "WA", StateName: "Washington", IsVisible: true }, { StateID: 51, State: "WV", StateName: "West Virginia", IsVisible: true }, { StateID: 50, State: "WI", StateName: "Wisconsin", IsVisible: true }, { StateID: 52, State: "WY", StateName: "Wyoming", IsVisible: true }, { StateID: 53, State: "XX", StateName: "XX", IsVisible: true }],
            uploadingFiles: []
        });

        function _reset() {
            $ctrl.paperApplication = {};
            $ctrl.uploadingFiles = [];
            $ctrl.paperApplication = {};
            $ctrl.searchTextProduct = "";
            $ctrl.searchTextCarrier = "";
        }

        function _getCarriers() {
            $ctrl.carriers = _.uniqBy($ctrl.products, 'PublicBusinessGuid'); //.map(function (a) { return a.Count; });
        }

        $ctrl.searchCarriers = function (searchTerm) {
            searchTerm = !!searchTerm ? searchTerm.toLowerCase() : "";
            var results = !!searchTerm
                ? _.filter($ctrl.carriers, function (row) {
                    if (row.Business && row.Business.toLowerCase().indexOf(searchTerm) !== -1) return true;
                    return false;
                })
                : $ctrl.carriers;
            return results;
        };

        $ctrl.searchProducts = function (searchTerm) {
            searchTerm = !!searchTerm ? searchTerm.toLowerCase() : "";
            var results = !!searchTerm
                ? _.filter($ctrl.products, function (row) {
                    if (row.Product && row.Product.toLowerCase().indexOf(searchTerm) !== -1) return true;
                    if (row.LineOfBusiness && row.LineOfBusiness.toLowerCase().indexOf(searchTerm) !== -1) return true;
                    return false;
                })
                : $ctrl.products;
            results = _.filter(results, function (row) {
                return row.PublicBusinessGuid === $ctrl.carrier.PublicBusinessGuid;
            });
            return results;
        };

        $ctrl.sendPolicyAndFilesToArc = function (policyModel) {
            $ctrl.ui.isSubmitting = true;
            var formData = new FormData();

            _.forEach(Object.keys(policyModel),
                function (key) {
                    formData.append(key, policyModel[key]);
                });

            $ctrl.uploadingFiles.forEach(function (file) {
                formData.append(file.notes, file, file.name);
            });
            var message = "", toastClass = "";
            reportsApi.postNewPolicyFiles(formData)
                .then(function (response) {
                    //message = fileCount === 1 ? "1 file uploaded successfully!" : fileCount + " files uploaded successfully!";
                    message = "Thank you! Your application has been sent to FIG Case Management for processing";
                    toastClass = "is-success";
                    _reset();
                    $ctrl.paperApp.$setUntouched();
                })
                .catch(function (error) {
                    message = "Error: something went wrong";
                    toastClass = "is-error";
                    console.log(error);
                })
                .finally(function () {
                    //$ctrl.ui.isUploading = false;
                    $ctrl.ui.isSubmitting = false;
                    $ctrl.closeDialog();
                    return figToaster.showSimple(message, "top", toastClass, 5000);
                });
        };

        $ctrl.uploadFiles = function (files, invalidFiles) {
            //$ctrl.isUploading = true;
            if ($ctrl.uploadForm.$invalid) {
                var invalidFileNames = _.map(invalidFiles,
                    function (file) {
                        return file.name;
                    }).join(", ");
                var toastClass = 'is-error';
                var toastMessage;
                //Added custom system feedback based on form validation
                if ($ctrl.uploadForm.$error.maxSize) {
                    toastMessage = 'File size cannot exceed 30MB per file. Please upload a different file.';
                }
                if ($ctrl.uploadForm.$error.pattern) {
                    toastMessage = 'File type is not supported. Please upload a different file.';
                }
                figToaster.showSimple(invalidFileNames + ' not uploaded. ' + toastMessage, "top", toastClass);
            }

            if (files.length > 0 && $ctrl.uploadForm.$valid) {
                //Add each valid file to filesList for uploading onSubmit
                files.forEach(function (file) {
                    $ctrl.uploadingFiles.push(file);
                });
            }
            //$ctrl.ui.isUploading = false;
        };

        $ctrl.removeFile = function (file) {
            //remove files from upload list before converting to formData
            $ctrl.uploadingFiles = _.remove($ctrl.uploadingFiles, function (activeFile) {
                return activeFile !== file;
            });
        };

        $ctrl.updateProduct = function () {
            $ctrl.paperApplication.PublicProductGuid = !!$ctrl.product
                ? $ctrl.product.PublicProductGuid
                : null;
        };
        $ctrl.$onInit = function () {
            $ctrl.ui.loading = true;
            var promises = [
                arcBusinessApi.getArcProducts()
            ];
            $q.all(promises)
                .then(function (response) {
                    $ctrl.products = response[0].Products;
                    _reset();
                    _getCarriers();
                })
                .finally(function () {
                    $ctrl.ui.loading = false;
                });
        };
    }
})(window.app, window.angular); // jshint ignore:line